// translations/pages/landing/es.js

export const landingPageES = {
  "hero": {
    "title": "pAIoneer Labs GmbH",
    "subtitle": "Soluciones de IA locales centradas en la protección de datos",
    "vision": "El siguiente nivel de productividad: Organisation as a Service. Los colaboradores de IA asumen el trabajo de la idea al resultado verificado.",
    "intro": "Investigamos, desarrollamos e integramos tecnologías de inteligencia artificial, aprendizaje automático y procesamiento de datos. De ahí nacen nuestros propios productos y soluciones a medida que analizan, estructuran, anonimizan y protegen los datos localmente — así como, con [Veridion](veridion), empleados de IA totalmente automatizados que junto con las personas asumen áreas completas de trabajo en la empresa.",
    "detail": "El software que instalamos para un cliente se ejecuta en su propia infraestructura y no necesita conexión a la nube. Los documentos, los datos y los modelos de lenguaje permanecen dentro de la empresa."
  },
  "partners": {
    "title": "Socios que confían en nosotros",
    "subtitle": "Empresas e instituciones de investigación en las que nuestra organización de IA funciona en producción.",
    "items": {
      "bisigma": {
        "name": "BiSigma",
        "tagline": "BioSignal Measurement and Analysis\nSoluciones de seguimiento ocular y biosiñales para su investigación",
        "description": [
          "BiSigma está especializada en sistemas para la medición y el análisis de bioseñales, así como en soluciones de seguimiento ocular (eye-tracking) de alta precisión para la ciencia, la práctica clínica y la investigación industrial.",
          "pAIoneer Labs GmbH ha sustituido por completo en BiSigma el desarrollo de software por IA, que desarrolla con éxito y evoluciona continuamente el software para la medición y el análisis de bioseñales."
        ],
        "cta": "Visitar BiSigma"
      }
    }
  },
  "products": {
    "title": "Productos",
    "subtitle": "Vendemos software como aplicación de escritorio para el puesto de trabajo, como software de servidor on-premises o en la nube del cliente y como suscripción en nuestra plataforma, por ejemplo, el [asistente de trading](finance), que nuestros colaboradores de IA desarrollan ellos mismos. Además, construimos sistemas de IA según los requisitos del cliente y ofrecemos consultoría y formación.",
    "partnerLabel": "Producto de un socio",
    "priceOnRequest": "Precio a consultar",
    "request": "Enviar una consulta",
    "items": {
      "kyveil": {
        "name": "Kyveil Desktop",
        "description": [
          "Kyveil detecta y anonimiza datos personales en archivos de Word, Excel, OpenDocument, PDF y texto antes de que pasen a herramientas de IA, pruebas o análisis, o se compartan con terceros. La detección combina {presidio}, {spacy} y {flair} y funciona en alemán, inglés, francés, italiano y español.",
          "La versión de escritorio funciona de forma autónoma en ordenadores convencionales con Windows, macOS o Linux, sin GPU y sin dependencias de red; los archivos no salen del puesto de trabajo. La versión API se ejecuta en la infraestructura del cliente, on-premises o en su propia nube, e integra la anonimización en los sistemas y flujos de trabajo existentes.",
          "El modo Replace sustituye los datos personales por marcadores para la documentación de cumplimiento normativo, y el modo Fake, por valores sustitutivos verosímiles para entornos de prueba; la estructura del documento se conserva. Con AnonChat, un documento anonimizado solo llega a ChatGPT, Claude, Gemini o a un modelo de lenguaje interno tras una vista previa."
        ],
        "cta": "Ver Kyveil"
      },
      "veridion": {
        "name": "Veridion Agentic Company Intelligence",
        "claim": "Un creador, infinitas soluciones.",
        "text": [
          "La IA corporativa de pAIoneer Labs GmbH: gobierna la empresa entera, como organización completa de colaboradores de IA con unidades de negocio desde el desarrollo de software, pasando por la electrónica y la computación cuántica, hasta las ventas y la administración, dirigidas por una capa de coordinación propia.",
          "Esta plantilla lleva hasta el final por sí misma proyectos, contabilidad, conocimiento corporativo, investigación, desarrollo y análisis de datos. Su comunicación está optimizada con teoría de juegos, y cuando necesita una capacidad que aún no existe, construye para ello un sistema de IA propio.",
          "Funciona en sus instalaciones, en su propia nube o en nuestra plataforma. Allí desarrolla ella misma el [asistente de trading](finance) y es la IA de su chat."
        ],
        "points": [
          "Se integra en cada proceso",
          "Aprende por sí sola",
          "Crea ella misma las capacidades que faltan",
          "Planificable en ciclos fijos"
        ],
        "cta": "Ver Veridion"
      },
      "robuddy": {
        "name": "RoBuddy",
        "description": [
          "RoBuddy es un sistema de agentes modular basado en IA para empresas que automatiza tareas administrativas de oficina.",
          "Cinco roles cubren el trabajo diario: el asistente coordina citas, redacta correos electrónicos y se ocupa de las tareas cotidianas. El coach acompaña los aspectos emocionales y sociales de la vida laboral, ayuda en los conflictos y apoya el desarrollo personal. El ayudante de protección de datos responde a preguntas especializadas sobre protección de datos y privacidad y puede entrenarse en otros ámbitos especializados, como la protección contra incendios o el cumplimiento normativo. El formador elabora planes de formación continua, procesos de incorporación y módulos formativos, y el asesor analiza los documentos cargados, apoya la toma de decisiones y ofrece recomendaciones estratégicas.",
          "RoBuddy se aloja y se gestiona al 100 % conforme a estándares alemanes (RGPD, BSI-Grundschutz) y se conecta sin fisuras a Nextcloud o a cualquier unidad de red.",
          "RoBuddy es el sistema agéntico para el trabajo de oficina y puede conectarse con Veridion para formar una IA corporativa que abarca toda la empresa: RoBuddy asume las tareas del puesto de trabajo y Veridion conecta los sistemas y los datos de la empresa."
        ],
        "cta": "Ver RoBuddy",
        "vendorNote": "RoBuddy es un producto de Dr. Hornecker Software-Entwicklung und IT-Dienstleistungen. La distribución corre a cargo de pAIoneer Labs GmbH."
      }
    }
  },
  "platformNote": {
    "title": "Plataforma SaaS",
    "description": "Esta aplicación se usa por suscripción directamente en el navegador, sin instalar nada. Se ejecuta en nuestra propia plataforma, el inicio de sesión exige un segundo factor y todas las llamadas a la IA pasan por un punto de acceso central con cuotas fijas.",
    "apps": {
      "finance": {
        "name": "Asistente de trading con IA",
        "text": "Usted conecta su cuenta de valores, hace preguntas sobre sus posiciones en lenguaje natural y ve qué noticias han movido las cotizaciones. Para cada instrumento financiero calcula la previsión un modelo propio de aprendizaje automático que se reentrena a diario, y un automatismo puede ejecutar las señales. El asistente lo desarrollan nuestros colaboradores de IA; en el chat son también su IA.",
        "cta": "Ver el asistente de trading"
      }
    }
  },
  "services": {
    "title": "Servicios principales",
    "veridion": {
      "title": "Colaboradores de IA",
      "description": "Campos de trabajo enteros, cubiertos con colaboradores de IA que se integran en los procesos y las herramientas de la empresa y llevan el trabajo hasta el final por sí mismos. Así trabajamos nosotros mismos: pAIoneer Labs GmbH funciona sobre ello.",
      "cta": "Ver Veridion",
      "features": [
        "Organisation as a Service",
        "Unidades de negocio de colaboradores de IA",
        "Comunicación optimizada con teoría de juegos",
        "En sus instalaciones o en su propia nube"
      ]
    },
    "custom": {
      "title": "Sistemas de IA a medida",
      "description": "Desarrollamos sistemas para el análisis, el procesamiento, la estructuración, la anonimización y la protección de datos según los requisitos del cliente y los integramos en infraestructuras de TI locales o propias del cliente.",
      "features": [
        "Funcionamiento sin nube",
        "Desarrollo de productos",
        "Prototipos",
        "Proyectos de investigación y desarrollo"
      ]
    },
    "dataanalysis": {
      "title": "Análisis de datos en conversación",
      "description": "Un colaborador de IA responde a las preguntas dirigidas a las fuentes de datos conectadas. Lee los catálogos, los esquemas y las columnas de las bases de datos, presenta un plan de análisis antes de acceder a los datos y aclara las ambigüedades.",
      "features": [
        "Fuentes de datos SQL",
        "Correlación y regresión",
        "Tablas y gráficos",
        "Exportación a PDF y PowerPoint"
      ]
    },
    "memory": {
      "title": "Memoria corporativa",
      "description": "Una memoria en lugar de una búsqueda de documentos: hechos, decisiones, tareas y procedimientos, vinculados a los proyectos, las personas, los sistemas y los documentos a los que pertenecen, junto con el tiempo en el que son válidos. Crece por sí sola a partir de conversaciones, reuniones y resultados de trabajo; una decisión más reciente sustituye a la anterior sobre el mismo tema, nada se pierde.",
      "features": [
        "Grafo de conocimiento",
        "Hechos con su tiempo",
        "Decisiones, nunca perdidas",
        "Acceso según la responsabilidad"
      ]
    },
    "elektronik": {
      "title": "Electrónica y firmware",
      "description": "Desarrollo cercano al hardware como servicio: diseño de circuitos y simulación como gemelo digital, firmware hasta el propio sensor, evaluación de componentes y alternativas antes de fabricar nada.",
      "features": [
        "Gemelos digitales",
        "Firmware embebido",
        "Análisis de hojas de datos",
        "Evaluación de componentes"
      ]
    },
    "quantum": {
          "title": "LLM Soberanos e IA Cuántica",
          "description": "Nuestro objetivo bajo Veridion: desarrollar modelos de lenguaje compactos Made in Germany que competirán con los grandes modelos de EE. UU. y China, junto con nuestros Quantum Transformers.",
          "cta": "Ver Quantum",
          "features": [
                "LLM Made in Germany",
                "Quantum Transformers",
                "Quantum IDE propia",
                "La IA desarrolla la IA"
          ]
    },
    "kyveil": {
      "title": "Anonimización local sin GPU",
      "description": "Kyveil anonimiza datos personales en local, como aplicación de escritorio en ordenadores convencionales con Windows, macOS o Linux o como API REST en la infraestructura del cliente, sin obligación de usar la nube y sin GPU.",
      "cta": "Ver Kyveil",
      "features": [
        "Anonimización antes de la IA",
        "Detección de PII con NLP",
        "Windows, macOS, Linux",
        "API REST on-premises"
      ]
    },
    "agenticdev": {
      "title": "Intent-Driven Development",
      "description": "El desarrollo de software asistido por IA necesita un contexto fiable. IDD recoge objetivos, no objetivos, escenarios, reglas para agentes y decisiones como memoria de proyecto utilizable.",
      "cta": "Ver IDD",
      "features": [
        "Desarrollo agéntico",
        "IDD Vault",
        "Intent/Decisions/Scenarios",
        "Escenarios como pruebas"
      ]
    },
    "finance": {
      "title": "Finanzas y análisis de mercado",
      "description": "Detrás del asistente de trading hay una unidad de negocio propia formada por colaboradores digitales: científicos de datos de IA y expertos en finanzas. Evalúan las noticias en tiempo real, analizan las emociones de las noticias financieras y calculan ellos mismos en el chat sobre los datos de mercado: correlaciones, regresiones, gráficos y el balance de sus propias previsiones, cada cifra a partir de un paso de cálculo ejecutado. Por debajo trabajan una previsión de aprendizaje automático por instrumento financiero y una operativa automática en cuenta demo y con dinero real.",
      "cta": "Ver finanzas",
      "features": [
        "Científicos de datos de IA y expertos en finanzas",
        "Noticias en tiempo real, con análisis de emociones",
        "Previsión de ML por instrumento financiero",
        "Operativa automática"
      ]
    },
    "consulting": {
      "title": "Consultoría",
      "description": "Asesoramos en los aspectos técnicos, organizativos y estratégicos de la implantación, la protección y el uso conforme a la normativa de la IA.",
      "features": [
        "Gobernanza de la IA",
        "Gestión de datos",
        "Protección de datos",
        "Seguridad de la información"
      ]
    }
  },
  "contact": {
    "title": "Contacto",
    "addressLabel": "Dirección",
    "phoneLabel": "Teléfono",
    "emailLabel": "Correo electrónico",
    "cta": "Escribir un mensaje"
  }
};
